import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";

/**
 * Lista com bullet redondo — o padrão de lista das seções do FlowFoundation.
 * `className` controla o espaçamento da `ul` (cada seção usa um gap próprio);
 * `itemClassName`/`dotClassName` só são sobrescritos no FAQ, que herda a
 * tipografia do acordeão e usa um cinza mais claro no bullet.
 */

type BulletListProps = {
  items: string[];
  className?: string;
  itemClassName?: string;
  dotClassName?: string;
};
export function BulletList(t0) {
  const $ = _c(12);
  const {
    items,
    className,
    itemClassName: t1,
    dotClassName: t2
  } = t0;
  const itemClassName = t1 === undefined ? "text-[15px] leading-[150%] text-gray-100/75" : t1;
  const dotClassName = t2 === undefined ? "bg-gray-100/75" : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn("flex flex-col", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== dotClassName || $[3] !== itemClassName || $[4] !== items) {
    let t5;
    if ($[6] !== dotClassName || $[7] !== itemClassName) {
      t5 = item => <li key={item} className={cn("flex gap-3", itemClassName)}><span aria-hidden="true" className={cn("mt-2 h-1.5 w-1.5 shrink-0 rounded-full", dotClassName)} /><span>{item}</span></li>;
      $[6] = dotClassName;
      $[7] = itemClassName;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = items.map(t5);
    $[2] = dotClassName;
    $[3] = itemClassName;
    $[4] = items;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <ul className={t3}>{t4}</ul>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}